import { args as clientArgs } from '@neo-one/client-core';
import * as args from './args';
export class ReadClient {
    constructor(dataProvider) {
        this.dataProvider = dataProvider;
    }
    async getAccount(address) {
        return this.dataProvider.getAccount(clientArgs.assertAddress('address', address));
    }
    async getAsset(hash) {
        return this.dataProvider.getAsset(clientArgs.assertHash256('hash', hash));
    }
    async getBlock(hash, optionsIn) {
        const options = args.assertGetOptions('options', optionsIn);
        if (typeof hash === 'number') {
            return this.dataProvider.getBlock(hash, options);
        }
        return this.dataProvider.getBlock(clientArgs.assertHash256('hash', hash));
    }
    iterBlocks(options) {
        return this.dataProvider.iterBlocks(args.assertIterOptions('options', options));
    }
    async getBestBlockHash() {
        return this.dataProvider.getBestBlockHash();
    }
    async getBlockCount() {
        return this.dataProvider.getBlockCount();
    }
    async getContract(address) {
        return this.dataProvider.getContract(clientArgs.assertAddress('address', address));
    }
    async getMemPool() {
        return this.dataProvider.getMemPool();
    }
    async getTransaction(hash) {
        return this.dataProvider.getTransaction(clientArgs.assertHash256('hash', hash));
    }
    async getOutput(input) {
        return this.dataProvider.getOutput(input);
    }
    async getConnectedPeers() {
        return this.dataProvider.getConnectedPeers();
    }
}

//# sourceMappingURL=ReadClient.js.map
